import { PageHero, SectionHeader } from '@/components/common/Sections';
import { TeamCard, CTABanner } from '@/components/common/Cards';
import { LEADERSHIP, IMAGES } from '@/lib/constants';

export default function LeadershipPage() {
  return (
    <div className="page-transition">
      <PageHero
        title="Leadership Team"
        subtitle="Meet the visionaries driving Osaka Group's success"
        backgroundImage={IMAGES.corporateTravel}
      />

      <section data-testid="leadership-section" className="section-padding bg-white">
        <div className="container-custom">
          <SectionHeader
            overline="Our Leaders"
            title="Guiding Osaka Group Forward"
            description="Our leadership team brings together decades of industry expertise and a shared vision for excellence in travel services."
          />

          <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
            {LEADERSHIP.map((member, index) => (
              <TeamCard key={member.name} member={member} index={index} />
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
